import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, requireRole }) {
  const auth = useAuth();
  const loc = useLocation();

  if (!auth || auth.status === "loading") {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }
  if (auth.status !== "auth") {
    const target = loc.pathname.startsWith("/master") ? "/master/login" : "/";
    return <Navigate to={target} state={{ from: loc }} replace />;
  }
  if (requireRole === "master_admin" && auth.user?.role !== "master_admin") {
    return <Navigate to="/" replace />;
  }
  if (requireRole === "tenant" && !auth.user?.tenant_id && auth.user?.role !== "master_admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
